<template>
  <div class="home">
<NavbarSesion/>
<ServiciosHero/>
<FooterHero/>

  </div>
</template>

<script>
import NavbarSesion from '@/components/NavbarSesion.vue';
import ServiciosHero from '@/components/servicios/ServiciosHero.vue';
import FooterHero from '@/components/FooterHero.vue';
export default {
  name: 'HomeView',
  components: {
NavbarSesion,
ServiciosHero,
FooterHero
  }
}
</script>
